import { render } from "./ChatFeedback.vue?vue&type=template&id=64b1c1b7"
import script from "./ChatFeedback.vue?vue&type=script&lang=js"
export * from "./ChatFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__